// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"230":"LocaleMessagePopover","358":"LanguageSelectionModal","524":"CurrencySelectionModal","650":"LocaleMessageModal"}[chunkId] + "." + {"230":"7ce0dbe0563b95c5c8b9","358":"a22ed5a9fc7f70643b72","524":"ca74c656ee7ed367a207","650":"841ba5ac168c999f9033"}[chunkId] + ".js";
};